import { __awaiter } from "tslib";
import { computed, defineComponent, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { DataSourceEnum } from '@/core/types/entities/hrgs/DataSourceEntities';
import { Actions } from '@/store/enums/hrgs/DataSourceEnum';
export default defineComponent({
    props: {
        modelValue: [String, Array, Number],
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },
        placeholder: String,
        disabled: Boolean,
        multiple: Boolean,
        dataSource: String
    },
    emits: ['update:modelValue', 'change'],
    setup(props, { emit }) {
        const store = useStore();
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        const employeeID = computed(() => {
            return store.getters.currentUser.employeeID;
        });
        const optionsValue = ref(props.options || []);
        watch(() => {
            return props.options;
        }, (newVal) => {
            optionsValue.value = newVal;
        }, {
            immediate: true
        });
        const change = (e) => {
            const found = props.options.find((item) => {
                return item.value === e;
            });
            emit('change', found);
        };
        // Use Data Source
        const searchList = ref(props.options || []);
        watch([
            () => {
                return props.dataSource;
            },
            employeeID
        ], ([newVal, employeeID]) => __awaiter(this, void 0, void 0, function* () {
            if (!(newVal && employeeID))
                return;
            if (newVal === DataSourceEnum.Education) {
                const results = yield store.dispatch(Actions.GET_EDUCATION);
                optionsValue.value = results.map((item) => {
                    return {
                        label: item.name,
                        value: String(item.id)
                    };
                });
            }
            else if (newVal === DataSourceEnum.Regency) {
                const results = yield store.dispatch(Actions.GET_PROVINCE);
                optionsValue.value = results.flatMap((result) => {
                    return result.regencies.map((regency) => {
                        return {
                            label: `${result.name} - ${regency.name}`,
                            value: String(regency.id)
                        };
                    });
                });
                searchList.value = results.flatMap((result) => {
                    return result.regencies.map((regency) => {
                        return {
                            label: `${result.name} - ${regency.name}`,
                            value: String(regency.id)
                        };
                    });
                });
            }
            else if (newVal === DataSourceEnum.Gender) {
                const results = yield store.dispatch(Actions.GET_GENDER);
                optionsValue.value = results.map((item) => {
                    return {
                        label: item.key,
                        value: String(item.value)
                    };
                });
            }
        }), {
            immediate: true
        });
        const loading = ref(false);
        const searchAble = () => {
            if (props.dataSource === DataSourceEnum.Regency) {
                return {
                    filterable: true,
                    remote: true,
                    reserveKeyword: true,
                    loading: loading.value,
                    remoteMethod: (query) => {
                        if (query) {
                            loading.value = true;
                            setTimeout(() => {
                                loading.value = false;
                                optionsValue.value = searchList.value.filter((item) => {
                                    var _a;
                                    return (_a = item.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(query.toLowerCase());
                                });
                            }, 200);
                        }
                        else {
                            optionsValue.value = [];
                        }
                    }
                };
            }
            return {};
        };
        return { DataSourceEnum, value, optionsValue, change, searchAble };
    }
});
